var map = {
	"./arrow-icon.svg": "8486",
	"./fb-icon.svg": "4a28",
	"./ig-icon.svg": "0690",
	"./in-icon.svg": "0d28",
	"./tk-icon.svg": "b3d0",
	"./tw-icon.svg": "1a67",
	"./yt-icon.svg": "55d3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c5ae";